<template>
  <div class="app-signin">
    <NowLogo img-width="48%" img-mt="15vh" img-align="center" />
    <WrappedImage
      class="ic-face"
      img-mt="5.2vh"
      img-align="center"
      :img-src="require('@/assets/images/ic-log-face.svg')"
    />
    <p>
      <strong>펀다나우</strong> 서비스에
      <br />오신 것을 환영합니다.
    </p>
    <p>
      펀다나우에서 정확한 매출 관리와
      <br />미래 매출까지 미리 정산받아보세요!
    </p>
    <div class="app-signin__btn-wrapper">
      <CommonButton
        class="mb-3"
        type="button"
        @click="signinKakao"
        btn-text="카카오계정으로 로그인"
        btn-theme="kakao"
      />
      <CommonButton
        type="button"
        @click="signinApple"
        :btn-icon="require('@/assets/images/symbol-apple-w.svg')"
        btn-text="Apple로 로그인"
        btn-theme="apple"
        v-show="device=='ios'"
      />
    </div>
  </div>
</template>
<script>
import NowLogo from '../../components/NowLogo'
import WrappedImage from '../../components/common/WrappedImage'
import CommonButton from '../../components/common/CommonButton'
import AuthService from '@/service/auth/AuthService'
import ChannelService from '@/service/channeltalk/ChannelService'

let debug = false
let self

let setDevice = function (device) {
  localStorage.setItem('device', device)
}

export default {
  components: { NowLogo, WrappedImage, CommonButton },
  data() {
    return {
      device: null
    }
  },
  async created() {
    self = this
    // Get Token
    this.device = this.$route.query.device || localStorage.getItem('device')
    let kakaoToken = this.$route.query.kakao_token
    let appleToken = this.$route.query.apple_token

    // Set Device
    if (!this.device) {
      this.$router.push({ name: 'main' })
      return
    } else {
      setDevice(this.device)
    }

    // Check Token
    if (!(kakaoToken || appleToken)) { return }

    // Check Token
    if (kakaoToken) {
      await AuthService.signinKakaoToken(kakaoToken)
      this.signin() // 로그인 성공
    } else if (appleToken) {
      await AuthService.signinAppleToken(appleToken)
      this.signin() // 로그인 성공
    }
  },
  methods: {
    signinKakao() {
      if (!(window.flutter_inappwebview && window.flutter_inappwebview.callHandler)) {
        self.$router.push({ name: 'main' })
        return
      }
      self.getKakaoTokenFromFlutter()
    },
    signinApple() {
      if (!window.flutter_inappwebview) {
        self.$router.push({ name: 'main' })
        return
      }
      self.getAppleTokenFromFlutter()
    },
    async signin() {
      if (debug) { console.log('signin') }
      await AuthService.syncProfile()
      ChannelService.boot()
      // Redirect Uri
      let redirectUri = this.$route.query.redirectUri
      if (redirectUri == null) { redirectUri = '/dashboard' }
      this.$router.push({ path: redirectUri })
    },
    getKakaoTokenFromFlutter() {
      if (window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('kakaoLogin')
      } else {
        window.flutter_inappwebview._callHandler('kakaoLogin', setTimeout(function () {}))
      }
    },
    getAppleTokenFromFlutter() {
      if (window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('appleLogin')
      } else {
        window.flutter_inappwebview._callHandler('appleLogin', setTimeout(function () {}))
      }
    }
  }
}

</script>
<style lang="scss" scoped>
@import '@/design/_colors.scss';

.app-signin {
  color: $black;
  width: 100%;
  max-width: 42.5rem;
  height: 100vh;
  position: fixed;
  background-color: $white;

  strong {
    font-weight: 900;
  }
  img.ic-face {
    margin-bottom: 12px;
  }
  p {
    text-align: center;
  }
  p:nth-of-type(1) {
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 3.3vh;
  }
  p:nth-of-type(2) {
    color: $light-black;
    font-size: 16px;
    line-height: 25px;
  }
  &__btn-wrapper {
    bottom: 0;
    position: fixed;
    width: 100%;
    padding: 30px 25px;
    background-color: $white;
  }
}
</style>
